import { Color } from "../enums/Color";
import { Font } from "../enums/Font";

export const applicationViewPage = {
    mobile: { 
        mainWrapper: {
            display: "flex",
            flexDirection: "column" as "column"
        },
        leftWrapper: {},
        rightWrapper: {
            margin: "0 4.83vw"
        },
        header: {
            display: "flex",
            flexDirection: "row" as "row",
            position: "relative",
            background: Color.Blue,
            marginTop: "0%",
            marginLeft: "0%",
            width: "100%",
            height: "18.77vw",
            opacity: "1",
            title: {
                margin: "4.83vw 0 4.83vw 4.83vw",
                cursor: "pointer",
                width: "39.37vw",
                height: "9.18vw"
            }
        },
        title: {
            fontSize: "6.04vw",
            fontWeight: "bold" as "bold",
            color: Color.LightBlack,
            marginTop: "3.62vw"
        },
        button: {
            width: "50.72vw",
            height: "8.45vw",                
            borderRadius: "1.2vw",
            fontSize: "3.38vw",
            fontWeight: "bold",
            color: Color.White,
            backgroundColor: Color.Blue,
            boxShadow: "5px 5px 50px #00000027",
            marginTop: "4.83vw",
            opacity: "1"
        },
        applicantInfoContainer: {
            margin: "4.83vw 0",
            border: "2px solid " + Color.Blue,
            padding: "4.83vw 2.41vw",
            borderRadius: "2.41vw"
        },
        applicantInfoWrapper: {
            display: "flex"
        },
        profileImage: {
            height: "24.33vw",
            width: "24.33vw",
            borderRadius: "50%",
            objectFit: "cover"                  
        },
        detailsWrapper: {
            marginLeft: "3.85vw",
            nameWrapper: {
                display: "flex"
            },
            name: {
                color: Color.LightBlack,
                fontSize: "6.03vw",
                fontWeight: "bold" as "bold",
                maxWidth: "49vw"
            },
            crownWrapper: {
                display: "flex",
                width: "6vw",
                height: "6vw",
                backgroundColor: Color.HarvestGold,
                borderRadius: "50%",
                margin: "1vw 0 0 1.45vw",
                alignItems: "center",
                justifyContent: "center"
            },
            crownIcon: {
                width: "3.2vw",
                fill: Color.White                
            },
            email: {
                color: Color.LightBlack,
                fontSize: "3.86vw",
                marginTop: "1.81vw",
                fontWeight: "bold" as "bold",
                wordBreak: "break-all",
                overflowWrap: "break-word",
                userSelect: "text",
                maxWidth: "100%"
            },
            appliedDate: {
                display: "flex",
                marginTop: "2.22vw",
                fontSize: "3.86vw",
                maxWidth: "54vw",
                color: Color.DeepAsh
            },
            applied: {
                fontWeight: "300",
                margin: "0 1vw 0 3.79vw"
            }, 
            text: {
                fontWeight: "bold" as "bold",
                maxWidth: "60vw",
                overflow: "hidden",
                whiteSpace: "nowrap",
                textOverflow: "ellipsis"
            },
            calendarIcon: {
                width: "3.26vw",
                height: "3.73vw",
                fill: Color.DeepAsh
            },
            statusWrapper: {
                display: "flex"
            },
            statusBadge: {
                height: "5.07vw",
                lineHeight: "5.07vw",
                borderRadius: "6.04vw",
                padding: "1vw 3.62vw",
                fontSize: "4.34vw",
                fontWeight: "500",
                marginTop: "2.41vw",
                flex: "0 0 auto",
                textAlign: "center",
                width: "40.04vw",
                screeningIncomplete: {
                    width: "45.04vw"
                },
                noShow: {
                    width: "42.04vw"
                },
                interviewOne: {
                    width: "50.04vw"
                },
                interviewTwo: {
                    width: "50.04vw"
                }
            }
        },
        premiumMessage: {                                
            position: "absolute",
            width: "auto", 
            padding: "1.82vw",
            marginTop: "21.41vw",
            marginLeft: "-18vw",
            fontSize: "3.38vw",
            border: "1px solid " + Color.Gray,
            borderRadius: "1vw",
            boxShadow: "3px 3px 10px #00000029",
            backgroundColor: Color.White,
            zIndex: "1",
            pointer: {
                position: "absolute",
                width: "2.8vw",
                height: "2.8vw",
                top: "-1.8vw",
                right: "15%",
                transform: "translateX(-50%) rotate(45deg)",                    
                backgroundColor: Color.White,
                borderTop: "1px solid " + Color.Gray,
                borderLeft: "1px solid " + Color.Gray,
                boxShadow: "-5px -5px 10px #00000029"
            }
        },
        moveToWrapper: {
            margin: "6.34vw 1vw 0",
            title: {
                color: Color.DeepAsh,
                fontWeight: "bold",
                fontFamily: Font.Poppins,
                fontSize: "3.86vw"
            },
            actions: {
                marginLeft: "0", 
                marginTop: "unset",
                width: "100%",
                label: {
                    alignSelf: "center",
                    marginRight: "2.89vw"
                },          
                buttonWrapper: { 
                    padding: "0 7.24vw",
                    border : `1px ${Color.SharpAsh} solid`,
                    width: "auto"
                },
                buttonText: {
                    marginLeft: "0",
                    color: Color.DeepAsh,
                    fontFamily: Font.Poppins,
                    fontSize: "3.86vw",
                    maxWidth: "60vw"
                },
                buttonIcon: {           
                    marginLeft: "auto",
                    marginRight: "0"
                },
                button: {
                    width: "auto",
                    marginLeft: "0",
                    height: "12.07vw"
                },
                hover: {
                    width: "82vw",
                    maxHeight: "30vw"
                },
                option: {
                    color: Color.DeepAsh,
                    fontFamily: Font.Poppins,
                    fontWeight: "300"
                },
                optionWrapper: {
                    display: "flex",
                    flexDirection: "row",
                    status: {
                        marginLeft: "1vw"
                    }
                },
                optionDot: {
                    width: "10px",
                    height: "10px",
                    borderRadius: "50%",
                    display: "block",
                    marginTop: "1vw",
                    marginRight: "3px"
                }
            }
        },
        moveButton: {
            button: {
                boxShadow: "5px 5px 50px #00000027",
                opacity: "1",
                width: "50.72vw",
                height: "8.45vw",                
                borderRadius: "1.69vw",
                fontSize: "3.38vw",
                margin: "3.38vw 0 0 1vw",
                fontWeight: "bold",
                color: Color.White,
                backgroundColor: Color.Green
            }
        },
        tabs: {
            container: {
                marginTop: "10.5vw"
            },
            linkWrapper: {
                display: "flex",
                flexDirection: "row",
                backgroundColor: Color.LightAsh,
                margin: "0",
                width: "fit-content",
                maxWidth: "85vw",
                overflowX: 'auto',
                overflowY: 'hidden',
                scrollbarWidth: "thin"
            },
            link: {
                flexShrink: "0",
                fontSize: "3.86vw",
                color: Color.DeepAsh,
                borderRadius: "1.20vw",
                padding: "2.65vw 4.8vw",
                alignSelf: "center",
                cursor: "pointer",
                active: {
                    backgroundColor: Color.DeepBlack,
                    color: Color.LightAsh,
                    position: "sticky",
                    right: "0",
                    left:"0"
                },
                WebkitTapHighlightColor: "transparent"
            },
            contentWrapper: {}
        },
        profileTab: {
            mainWrapper: {
                margin: "0 2vw 0 1vw"
            },
            title: {
                color: Color.LightBlack,
                fontWeight: "bold",
                fontSize: "6.03vw",
                margin: "3.23vh 0 0 0"
            },
            personalSummary: {
                marginTop: "9.90vw",
                title: {
                    color: Color.LightBlack,
                    fontWeight: "bold",
                    fontSize: "4.83vw"
                },
                text: {
                    color: Color.MiddleBlack,
                    fontSize: "3.86vw",
                    marginTop: "7.24vw",
                    userSelect: "text"
                }
            },
            seeMore: {
                color: Color.Blue,
                fontWeight: "bold",
                marginLeft: "2vw",
                cursor: "pointer"
            },
            details: {
                marginTop: "7.24vw",
                box: {
                    borderRadius: "2.41vw",
                    border: "1px solid " + Color.SharpAsh,
                    marginBottom: "2.41vw",
                    padding: "2.65vw 4.83vw"
                },
                title: {
                    color: Color.DeepAsh,
                    fontWeight: "bold",
                    fontFamily: Font.Poppins,
                    fontSize: "4.34vw"
                },
                text: {
                    color: Color.DeepAsh,
                    fontFamily: Font.Poppins,
                    fontSize: "3.86vw",
                    userSelect: "text"
                }
            }
        },
        infoTab: {
            mainWrapper: {
                margin: "0 2vw 0 1vw"
            },
            title: {
                color: Color.LightBlack,
                fontWeight: "bold",
                fontSize: "6.03vw",
                margin: "3.23vh 0 0 0"
            },
            details: {
                marginTop: "7.24vw",
                box: {
                    borderRadius: "2.41vw",
                    border: "1px solid " + Color.SharpAsh,
                    marginBottom: "2.41vw",
                    padding: "2.65vw 4.83vw"
                },
                title: {
                    color: Color.DeepAsh,
                    fontWeight: "bold",
                    fontFamily: Font.Poppins,
                    fontSize: "4.34vw",
                    preferredSectors: {
                        marginBottom: "2vw"
                    }
                },
                text: {
                    color: Color.DeepAsh,
                    fontFamily: Font.Poppins,
                    fontSize: "3.86vw",
                    userSelect: "text"
                },
                qualifications: {
                    color: Color.DeepAsh,
                    fontWeight: "300",
                    fontFamily: Font.Poppins,
                    fontSize: "4.34vw",
                    margin: "5.79vw 0 2.41vw 2.41vw"
                },
                sector: {
                    width: "fit-content",
                    height: "3.91vh",
                    paddingLeft: "4.83vw",
                    paddingRight: "4.83vw",
                    marginRight: "1.21vw",
                    marginBottom: "0.56vh",
                    textAlign: "center",
                    lineHeight: "3.91vh",
                    borderRadius: "6.04vw",
                    backgroundColor: Color.Blue,
                    color: Color.LightBlue,
                    fontSize: "3.62vw",
                    overflow: "hidden",
                    cursor: "pointer",
                    display: "inline-block",
                    flex: "0 0 auto",
                    WebkitTapHighlightColor: "transparent",
                    userSelect: "none"
                }
            }
        },
        answersTab: {
            mainWrapper: {
                margin: "0 2vw 0 1vw"
            },
            rowWrapper: {
                display: "flex",
                flexDirection: "row",
                alignItems: "baseline",
                margin: "3.23vh 0 0.78vh 0"
            },
            title: {
                color: Color.LightBlack,
                fontWeight: "bold",
                fontSize: "6.03vw"
            },
            total: {
                color: Color.LightBlack,
                fontWeight: "bold",
                marginLeft: "auto",
                marginRight: "4.83vw",
                fontSize: "4.34vw"
            },
            score: {
                color: Color.DeepBlack,
                fontWeight: "bold",
                fontSize: "7.24vw"
            },
            text: {
                color: Color.DeepAsh,
                marginLeft: "3.79vw",
                fontSize: "3.86vw"
            },
            screeningStatus: {
                display: "flex",
                margin: "1.69vw 0 6.28vw 0",
                alignItems: "center",
                icon: {
                    width: "3.73vw",
                    height: "3.73vw",
                    marginLeft: "auto"
                }, 
                text: {
                    marginLeft: "3.56vw",
                    color: Color.DeepAsh,
                    fontSize: "3.86vw"
                },
                bold: {
                    fontWeight: "bold"
                }
            },
            questionWrapper: {},
            question: {
                display: "flex",
                flexDirection: "column",
                borderRadius: "2.41vw",
                border: "3px solid " + Color.Gainsboro,
                padding: "4.83vw 6.28vw",
                marginTop: "3.86vw",
                row: {
                    display: "flex",
                    flexDirection: "row" as "row",
                },
                text: {
                    color: Color.DeepAsh,
                    whiteSpace: "pre-line",
                    marginTop: "4.83vw",
                    fontWeight: "400",
                    fontFamily: Font.Poppins,
                    fontSize: "4.34vw",
                    maxWidth: "60vw",
                    paddingRight: "4vw",
                    userSelect: "text"
                },
                knockout: {
                    color: Color.Red,
                    marginLeft: "2vw",
                    fontWeight: "400",
                    fontFamily: Font.Poppins,
                    fontSize: "4.34vw"
                },
                score: {
                    color: Color.DeepAsh,
                    margin: "4.83vw 0 0 auto",
                    height: "8.21vw",
                    borderLeft: "2px solid " + Color.Gainsboro,
                    paddingLeft: "5.67vw",
                    fontWeight: "400",
                    fontFamily: Font.Poppins,
                    fontSize: "4.34vw",
                    display: "flex"
                },
                icon: {
                    width: "4.73vw",
                    height: "4.73vw",
                    alignSelf: "center",
                    overflow: "visible"
                }
            },
            questionNumber: {
                color: Color.DeepAsh,
                fontWeight: "bold",
                fontFamily: Font.Poppins,
                fontSize: "4.34vw"
            },
            answerWrapper: {
                text: {
                    color: Color.DeepAsh,
                    marginTop: "4.83vw",
                    fontWeight: "bold",
                    fontFamily: Font.Poppins,
                    fontSize: "4.34vw"
                },
                answers: {
                    color: Color.DeepAsh,
                    whiteSpace: "pre-line",
                    margin: "4.83vw 0",
                    fontWeight: "400",
                    fontFamily: Font.Poppins,
                    fontSize: "4.34vw",
                    userSelect: "text"
                },
                list: {
                    margin: 0, 
                    paddingLeft: "4.83vw"
                },
                seeMore: {
                    color: Color.Blue,
                    fontWeight: "bold",
                    marginLeft: "2vw",
                    cursor: "pointer"
                }
            }
        },
        cvTab: {
            mainWrapper: {
                margin: "0 2vw 0 1vw"
            },
            rowWrapper: {
                display: "flex",
                flexDirection: "row",
                margin: "3.23vh 0 2.67vh"
            },
            text: {
                color: Color.LightBlack,
                fontWeight: "bold",
                fontSize: "6.03vw"
            },
            link: {
                marginLeft: "4.62vw",
                textDecoration: "none",
                color: Color.Blue,
                textAlign: "center",
                cursor: "pointer",
                display: "flex",
                alignItems: "center",
                fontSize: "3.86vw"
            },
            icon: {
                marginLeft: "0.92vw",
                stroke: Color.Blue,
                width: "2.93vw",
                height: "2.93vw"
            },
            button: {
                marginLeft: "auto",
                width: "32.36vw",
                height: "8.45vw",                
                borderRadius: "2.41vw",
                fontSize: "4.34vw",
                border: "2px solid " + Color.Green,
                color: Color.LightBlack,
                backgroundColor: Color.White
            },
            holder: {
                position: "relative" as "relative",
                border: "1px solid " + Color.MiddleAsh,
                borderRadius: "2.41vw",
                height: "122.46vw",
                marginBottom: "7.60vw",
                overflow: "hidden",
                paddingBottom: "14vw"
            },
            cvWrapper: {
                position: "relative" as "relative",
                height: "100%"
            },
            cvOverlay: {
                display: "none"
            },
            name: {
                marginBottom: "7px",
                position: "absolute" as "absolute",
                left: "1.04vw",
                bottom: "1.04vw",
                fontSize: "4.34vw",
                color: Color.Black
            },
            popup:{
                justifyContent: "center",
                container: {
                    width: "90.33vw",
                    height: "166.67vw",
                    borderRadius: "2.41vw",
                    padding: "2.41vw"
                },
                closeButton: {
                    width: "5.86vw",
                    height: "5.86vw",
                    top: "1.93vw",
                    right: "1.93vw"
                }
            },             
            documentViewer: {
                height: "100%"
            } 
        },
        quizTab: {
            rowWrapper: {
                display: "flex",
                flexDirection: "row",
                alignItems: "baseline",
                margin: "3.23vh 0 2.90vh 0"
            },
            title: {
                color: Color.LightBlack,
                fontWeight: "bold",
                fontSize: "6.03vw"
            },
            quiz: {
                display: "flex",
                marginTop: "2vw",
                height: "auto",
                backgroundColor: Color.LightAsh,
                fontWeight: "600",
                fontSize: "3.86vw",
                color: Color.MiddleBlack,
                padding: "2vw",
                icon: {
                    width: "5vw",
                    height: "5vw",
                    alignSelf: "center",
                    overflow: "visible",
                    marginRight: "3vw"
                },
                quizDetails: {
                    marginLeft: "auto"
                }
            },
            question: {
                display: "flex",
                flexDirection: "column",
                borderRadius: "2.41vw",
                border: "3px solid " + Color.Gainsboro,
                padding: "4.83vw 6.28vw",
                marginTop: "3.86vw",
                row: {
                    display: "flex",
                    flexDirection: "row" as "row",
                },
                text: {
                    color: Color.DeepAsh,
                    marginTop: "4.83vw",
                    fontWeight: "400",
                    fontFamily: Font.Poppins,
                    fontSize: "4.34vw"
                },
                score: {
                    color: Color.DeepAsh,
                    margin: "4.83vw 0 0 5.67vw",
                    height: "8.21vw",
                    borderLeft: "2px solid " + Color.Gainsboro,
                    paddingLeft: "5.67vw",
                    fontWeight: "400",
                    fontFamily: Font.Poppins,
                    fontSize: "4.34vw"
                }
            },
            questionNumber: {
                color: Color.DeepAsh,
                fontWeight: "bold",
                fontFamily: Font.Poppins,
                fontSize: "4.34vw"
            },
            answerWrapper: {
                text: {
                    color: Color.DeepAsh,
                    marginTop: "4.83vw",
                    fontWeight: "bold",
                    fontFamily: Font.Poppins,
                    fontSize: "4.34vw"
                },
                answers: {
                    marginTop: "4.83vw",
                    fontWeight: "400",
                    fontFamily: Font.Poppins,
                    fontSize: "4.34vw",
                    red: {
                        color: Color.Red
                    },
                    green : {
                        color: Color.Green
                    }
                }
            }
        },
        coverLetterTab: {
            mainWrapper: {
                margin: "0 2vw 0 1vw"
            },
            rowWrapper: {
                display: "flex",
                flexDirection: "row",
                alignItems: "baseline",
                margin: "3.23vh 0 2.90vh 0"
            },
            title: {
                color: Color.LightBlack,
                fontWeight: "bold",
                fontSize: "6.03vw"
            },
            coverLetter: {
                display: "flex",
                flexDirection: "column",
                borderRadius: "2.41vw",
                border: "3px solid " + Color.Gainsboro,
                padding: "4.83vw 6.28vw",
                marginTop: "3.86vw",
                text: {
                    color: Color.DeepAsh,
                    fontWeight: "400",
                    fontFamily: Font.Poppins,
                    fontSize: "4.34vw"
                }
            }
        },
        notesTab: {
            mainWrapper: {
                margin: "0 2vw 0 1vw"
            },
            rowWrapper: {
                display: "flex",
                flexDirection: "row",
                alignItems: "baseline",
                marginTop: "3.23vh"
            },
            title: {
                color: Color.LightBlack,
                fontWeight: "bold",
                fontSize: "6.03vw"
            },
            noteWrapper: {
                padding: "4.83vw 6.28vw",
                marginTop: "4.66vw",
                borderRadius: "2.41vw",
                border: "3px solid " + Color.Gainsboro,
                text: {
                    color: Color.DeepAsh,
                    fontWeight: "bold",
                    fontSize: "4.34vw",
                    fontFamily: Font.Poppins
                },
                input: {
                    border: "none",
                    width: "90%",
                    minHeight: "44.44vw",                
                    borderRadius: "2.41vw",
                    marginTop: "3.86vw",
                    padding: "3.38vw",
                    backgroundColor: Color.LightAsh,
                    resize: "none"
                },
                buttons: {
                    marginTop: "3.86vw",
                    display: "flex"
                },
                addNoteButton: {
                    width: "100%",
                    height: "8.45vw",                
                    borderRadius: "1.69vw",
                    fontSize: "3.38vw",
                    fontWeight: "bold",
                    color: Color.White,
                    backgroundColor: Color.Green,
                    boxShadow: "5px 5px 50px #00000027",
                    opacity: "1"
                },
                discardButton: {
                    width: "29.46vw",
                    height: "8.45vw",                
                    borderRadius: "1.93vw",
                    marginLeft: "2.41vw",
                    fontSize: "3.38vw",
                    fontWeight: "bold",
                    color: Color.DeepBlack,
                    border: "2px solid " + Color.DeepBlack,
                    backgroundColor: Color.White,
                    opacity: "1"
                }
            },
            previousNote: {
                padding: "5.79vw",
                marginTop: "5.79vw",
                borderRadius: "2.41vw",
                border: "3px solid " + Color.Gainsboro,
                recordInfo: {
                    display: "flex"
                },
                calendarIcon: {
                    width: "3.26vw",
                    height: "3.73vw"
                },
                details: {
                    marginLeft: "3.79vw",
                    fontSize: "3.86vw",
                    color: Color.DeepAsh
                },
                addedDate: {
                    fontWeight: "bold"
                },
                note: {
                    marginTop: "3.62vw",
                    color: Color.DeepAsh,
                    fontFamily: Font.Poppins,
                    fontSize: "4.34vw"
                }
            }
        },
        dialog: {   
            container: {
                width: "calc(100% - 9.66vw)",
                height: "40.83vw",
                padding: "7.246vw 4.93vw",
                borderRadius: "2.415vw 2.415vw 0 0"
            },
            closeButton: {
                width: "4.58vw",
                height: "4.58vw",
                top: "3.41vw",
                right: "5.70vw"
            },
            title: {
                margin: "0 0 2.41vw",
                fontSize: "5.86vw",
                color: Color.MiddleBlack,
                lineHeight: "5vw",
                justifySelf: "center",
                fontWeight: "bold" as "bold"
            },
            message: {
                fontSize: "4vw",
                color: Color.MiddleBlack,
                justifySelf: "center",
                fontWeight: 300,
                textAlign: 'center'
            },
            cancel: {
                background: Color.LightAsh,
                borderRadius: "2.41vw",
                height: "12vw",            
                width: "42vw",       
                fontWeight: "bold" as "bold",
                color: Color.SharpAsh,
                fontSize: "4vw",
                float: "right" as "right",
                marginTop: "7vw",
                marginRight: 0,
                padding: 0
            },
            move: {
                backgroundColor: Color.Green,            
                borderRadius: "2.41vw",
                color: Color.White,
                height: "12vw",
                width: "42vw",
                border: "none",            
                fontSize: "4vw",            
                fontWeight: "bold" as "bold",
                float: "left" as "left",
                marginTop: "7vw",
                marginLeft: 0
            }                     
        }
    },
    desktop: {
        mainWrapper: {            
            flexDirection: "row" as "row"
        },        
        leftWrapper: {
            display: "none"
        },
        rightWrapper: {
            margin: "unset",
            display: "flex",
            flexDirection: "column" as "column",
            width: "100%"
        },
        header: {
            height: "6.2vw",
            title: {
                margin: "1.28vw 0 1.28vw 2.70vw",
                width: "15.52vw",
                height: "3.65vw"  
            }
        },
        title: {
            color: Color.DeepBlack,
            fontSize: "1.56vw",
            margin: "2.5vw 0 0 2.5vw"
        },
        button: {
            height: "2.6vw",     
            width: "13.6vw",           
            borderRadius: "0.36vw",
            margin: "1.04vw 10vw 0 auto",
            fontSize: "0.83vw"
        },
        applicantInfoContainer: {
            margin: "2vw 10vw 5vw",
            borderRadius: "0.52vw",
            padding: "1.04vw 1vw"
        },
        profileImage: {
            height: "7.91vw",
            width: "7.91vw"                  
        },
        detailsWrapper: {
            marginLeft: "1.35vw",
            name: {
                color: Color.DeepBlack,
                fontSize: "1.56vw"
            },
            crownWrapper: {
                width: "1.77vw",
                height: "1.77vw",
                margin: "0 0 0 1vw"
            },
            crownIcon: {
                width: "1.04vw",
                height: "1.48vh"
            },
            email: {
                fontSize: "0.93vw",
                marginTop: "0.23vw"
            },  
            appliedDate: {
                marginTop: "0.71vw"
            },
            applied: {
                margin: "0 0.4vw 0 0.81vw"
            },
            text: {
                fontSize: "0.83vw",
                maxWidth: "18vw"
            },
            calendarIcon: {
                width: "0.70vw",
                height: "0.80vw"
            },
            statusBadge: {
                height: "1.82vw",
                lineHeight: "1.82vw",
                borderRadius: "1.30vw",
                padding: "0 1.04vw",
                fontSize: "0.94vw",
                marginTop: "0.61vw",
                cursor: "pointer",
                width: "7.97vw",
                screeningIncomplete: {
                    width: "9.97vw"
                },
                noShow: {
                    width: "9.97vw"
                },
                interviewOne: {
                    width: "10.97vw"
                },
                interviewTwo: {
                    width: "10.97vw"
                },
                expandedAndHovered: {
                    padding: "0 0.3vw"
                }
            }
        },
        premiumMessage: {
            borderRadius: "0.6vw",                
            padding: "0.625vw",
            marginTop: "6vw",
            marginLeft: "-4.8vw",
            fontSize: "0.83vw",
            pointer: {
                top: "-0.4vw",
                bottom: "unset",
                width: "0.7vw",
                height: "0.6vw"
            }
        },
        moveSection: {
            display: "flex",
            marginLeft: "9.26vw"
        },
        moveToWrapper: {
            margin: "0.61vw 0 0 0",
            title: {
                fontSize: "0.93vw"
            },
            actions: {
                width: "15.21vw",
                marginTop: "1.04vw",
                label: {
                    marginRight: "unset" 
                }, 
                buttonWrapper: {
                    padding: "0 1.56vw"
                },
                buttonText: {
                    maxWidth: "none",
                    fontSize: "0.83vw"
                },
                button: {
                    width: "100%",
                    height: "2.64vw"
                },
                hover: {
                    paddingLeft: "unset", 
                    maxHeight: "9vw",
                    width: "15.1vw"
                },
                optionWrapper: {
                    status: {
                        marginLeft: "unset"
                    }
                },
                optionDot: {
                    width: "7px",
                    height: "7px",
                    marginTop: "unset",
                    alignSelf: "center",
                    marginRight: "4px"
                }
            }
        },
        moveButton: {
            display: "flex",
            button: {
                width: "10.93vw",
                height: "1.82vw",                
                borderRadius: "0.36vw",
                fontSize: "0.72vw",
                margin: "0.61vw 0 0 3vw",
                alignSelf: "end"
            }
        },
        tabs: {
            container: {
                marginTop: "10vh"
            },
            linkWrapper: {
                borderRadius: "0.52vw",
                maxWidth: "77vw"
            },
            link: {
                fontSize: "0.83vw",
                borderRadius: "0.52vw",
                padding: "0.67vw 3.56vw",
                active: {
                    borderRadius: "0.52vw"                    
                }
            },
            title: {
                fontSize: "1.56vw",
                marginTop: "4.63vh"
            } 
        },
        profileTab: {
            mainWrapper: {
                margin: "unset"
            },
            title: {
                color: Color.DeepBlack,
                fontSize: "1.56vw",
                margin: "3.70vh 0 0 0"
            },
            personalSummary: {
                marginTop: "2.08vw",
                title: {
                    fontSize: "1.04vw"
                },
                text: {
                    fontSize: "0.83vw",
                    marginTop: "1.56vw"
                }
            },
            seeMore: {
                marginLeft: "0.5vw"
            },
            details: {
                margin: "1.56vw 0 0",
                box: {
                    borderRadius: "0.52vw",
                    marginBottom: "0.52vw",
                    padding: "0.57vw 1.04vw"
                },
                title: {
                    fontSize: "0.93vw"
                },
                text: {
                    fontSize: "0.83vw"
                }
            }
        },
        infoTab: {
            mainWrapper: {
                margin: "unset"
            },
            title: {
                color: Color.DeepBlack,
                fontSize: "1.56vw",
                marginTop: "3.70vh"
            },
            details: {
                margin: "1.56vw 0 0",
                box: {
                    borderRadius: "0.52vw",
                    marginBottom: "0.52vw",
                    padding: "0.57vw 1.04vw"
                },
                title: {
                    fontSize: "0.93vw",
                    preferredSectors: {
                        marginBottom: "0.52vw"
                    }
                },
                text: {
                    fontSize: "0.83vw"
                },
                qualifications: {
                    fontSize: "0.93vw",
                    margin: "1.25vw 0 0.52vw 0.52vw"
                },
                sector: {
                    marginRight: "0.52vw",
                    marginBottom: "0.52vw",
                    width: "fit-content",
                    height: "1.822vw",
                    paddingLeft: "1.04vw",
                    paddingRight: "1.04vw",
                    lineHeight: "1.822vw",
                    fontSize: "0.78vw"
                }
            }
        },
        answersTab: {
            mainWrapper: {
                margin: "unset"
            },
            rowWrapper: {
                margin: "3.70vh 0 0 0",
                alignItems: "center"
            },
            title: {
                color: Color.DeepBlack,
                fontSize: "1.56vw"
            },
            total: {
                margin: "0 1.04vw 0 0",
                fontSize: "0.93vw"
            },
            score: {
                fontSize: "1.56vw",
                marginRight: "1.19vw"
            },
            text: {
                marginLeft: "0.81vw",
                fontSize: "0.83vw"
            },
            screeningStatus: {
                margin: "0.1vw 0 0 auto",
                alignItems: "end",
                icon: {
                    width: "0.8vw",
                    height: "0.8vw"
                }, 
                text: {
                    margin: "0 1.14vw 0 0.76vw",
                    fontSize: "0.83vw"
                }
            },
            questionWrapper: {
                margin: "1.25vw 0 0"
            },
            question: {
                borderRadius: "0.52vw",
                padding: "1.04vw 1.35vw",
                marginTop: "0.72vw",
                text: {
                    marginTop: "1.04vw",
                    fontSize: "0.93vw",
                    padding: 0,
                    maxWidth: "100%"
                },
                knockout: {
                    fontSize: "0.93vw",
                    marginLeft: "0.3vw"
                },
                score: {
                    margin: "1.04vw 0 0 auto",
                    paddingLeft: "1.22vw",
                    fontSize: "0.93vw",
                    height: "1.77vw"
                },
                icon: {
                    width: "1.5vw",
                    height: "1.5vw"
                }
            },
            questionNumber: {
                fontSize: "0.93vw"
            },
            answerWrapper: {
                text: {
                    marginTop: "1.04vw",
                    fontSize: "0.93vw"
                },
                answers: {
                    margin: "1.04vw 0",
                    fontSize: "0.93vw"
                },
                list: {
                    paddingLeft: "1.04vw"
                },
                seeMore: {
                    marginLeft: "0.5vw"
                }
            }
        },
        cvTab: {
            mainWrapper: {
                margin: "unset"
            },
            rowWrapper: {
                margin: "3.70vh 0 2.31vh"
            },
            text: {
                color: Color.DeepBlack,
                fontSize: "1.56vw"
            },
            link: {
                marginLeft: "57.6vw",
                fontSize: "0.83vw"
            },
            icon: {
                marginLeft: "0.32vw",
                width: "0.7vw",
                height: "0.7vw"
            },
            button: {
                width: "6.97vw",
                height: "1.82vw",                
                borderRadius: "0.52vw",
                fontSize: "0.93vw"
            },
            holder: {
                borderRadius: "0.52vw",
                height: "35.2vw",
                marginBottom: "2vw",
                paddingBottom: "unset"
            },
            cvOverlay: {
                display: 'inline',
                position: "absolute" as "absolute",
                top: 0,
                right: "25vw",
                left: "24vw",
                bottom: 0,
                cursor: "pointer"
            },
            name: {
                marginBottom: "7px",
                fontSize: "1.04vw"
            },
            popup:{
                container: {                    
                    width: "30.99vw",
                    height: "43.85vw",                    
                    borderRadius: "0.52vw",
                    padding: "0.83vw"
                },
                closeButton: {                    
                    width: "1.2vw",
                    height: "1.2vw",
                    top: "0.21vw",
                    right: "0.21vw"
                }
            }
        },
        quizTab: {
            rowWrapper: {
                margin: "3.70vh 0 2.22vh 0"
            },
            quizWrapper: {
                marginBottom: "3vw",
                cursor: "pointer"
            },
            title: {
                color: Color.DeepBlack,
                fontSize: "1.56vw"
            },
            quiz: {
                marginTop: "1vw",
                padding: "0.5vw",
                fontSize: "1.04vw",
                quizDetailsWrapper: {
                    display: "flex",
                    width: "100%",
                    fontSize: "0.93vw",
                    alignItems: "center"
                },
                quizName: {
                    maxWidth: "50vw"
                },
                icon: {
                    width: "1vw",
                    height: "1vw",
                    marginRight: "0.5vw"
                }
            },
            question: {
                borderRadius: "0.52vw",
                padding: "1.04vw 1.35vw",
                marginTop: "0.72vw",
                text: {
                    marginTop: "1.04vw",
                    fontSize: "0.93vw"
                },
                score: {
                    margin: "1.04vw 0 0 1.04vw",
                    paddingLeft: "1.22vw",
                    fontSize: "0.93vw",
                    height: "1.77vw"
                }
            },
            questionNumber: {
                fontSize: "0.93vw"
            },
            answerWrapper: {
                text: {
                    marginTop: "1.04vw",
                    fontSize: "0.93vw"
                },
                answers: {
                    marginTop: "1.04vw",
                    fontSize: "0.93vw"
                }
            }
        },
        coverLetterTab: {
            mainWrapper: {
                margin: "unset"
            },
            rowWrapper: {
                margin: "3.70vh 0 2.22vh 0"
            },
            title: {
                color: Color.DeepBlack,
                fontSize: "1.56vw"
            },
            coverLetter: {
                borderRadius: "0.52vw",
                padding: "1.04vw 1.35vw",
                margin: "0.72vw 0 2vw 0",
                text: {
                    fontSize: "0.93vw"
                }
            }
        },
        notesTab: {
            mainWrapper: {
                margin: "unset"
            },
            rowWrapper: {
                marginTop: "3.7vh"
            },
            title: {
                color: Color.DeepBlack,
                fontSize: "1.56vw"
            },
            noteSection: {
                marginBottom: "2vw"
            },
            noteWrapper: {
                padding: "1.04vw 0.83vw",
                margin: "1vw 0 1.25vw",
                borderRadius: "0.36vw",
                text: {
                    fontSize: "0.93vw"
                },
                input: {
                    minHeight: "9.58vw",                
                    borderRadius: "0.52vw",
                    marginTop: "0.83vw",
                    width: "96.5%",
                    padding: "1.25vw"
                },
                buttons: {
                    marginTop: "0.83vw"
                },
                addNoteButton: {
                    width: "10.93vw",
                    height: "1.82vw",                
                    borderRadius: "0.36vw",
                    fontSize: "0.72vw"
                },
                discardButton: {
                    width: "6.35vw",
                    height: "1.82vw",               
                    borderRadius: "0.41vw",
                    marginLeft: "auto",
                    fontSize: "0.72vw"
                }
            },
            previousNote: {
                padding: "1.25vw",
                margin: "0 0 0.73vw",
                borderRadius: "0.52vw",
                calendarIcon: {
                    width: "0.70vw",
                    height: "0.8vw"
                },
                details: {
                    marginLeft: "0.81vw",
                    fontSize: "0.83vw"
                },
                note: {
                    overflowWrap: "break-word",
                    marginTop: "0.41vw",
                    fontSize: "0.93vw"
                }
            }
        },
        dialog: {            
            container: {                
                width: "30vw",
                height: "10vw",
                maxHeight: "31.61vw",
                padding: "2.48vw 2.12vw",
                borderRadius: "0.52vw"
            },
            closeButton: {
                fill: Color.Gainsboro,
                stroke: Color.Gainsboro,
                strokeWidth: 4,
                width: "0.59vw",
                height: "0.59vw",
                top: "0.90vw",
                right: "0.90vw"
            },
            title: {
                margin: "0 1vw 1vw",
                fontSize: "1.6vw",                
                lineHeight: "2vw",
                fontWeight: "500"
            },
            message: {
                fontSize: "0.94vw",
                marginBottom: "1.5vw"
            },
            buttons: {
                display: "flex"
            },
            cancel: {
                borderRadius: "0.52vw",
                height: "4.20vw",
                width: "14vw",                         
                fontSize: "1.6vw",
                float: "left" as "left",
                marginTop: "unset",
                marginRight: 0,
                padding: 0
            },
            move: {                           
                borderRadius: "0.52vw",                
                height: "4.20vw",
                width: "14vw",                    
                fontSize: "1.6vw",                            
                float: "right" as "right",
                margin: "0 1vw 0 0"
            } 
        }
    }
}